import React, { useState } from 'react';
import axios from 'axios';
import './AuthStyle.css';
import { withRouter } from 'react-router-dom';
import { API_URL } from '../../../redux/consts';
import Cookies from 'js-cookie';

const ResetPassword = ({ match, history }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Extracting parameters from match prop
  const { uid, token } = match.params;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords don't match");
      return;
    }
    try {
      const csrfToken = Cookies.get('csrftoken'); // Get CSRF token from cookies
      const response = await axios.post(`${API_URL}/api/reset-password/`, {
        headers: {
        'X-CSRFToken': csrfToken,
      },
        withCredentials: true,
        uid,
        token,
        new_password: password
      });
      setMessage(response.data.message);
      setError('');

      setTimeout(() => {
        history.push('/login');
      }, 2000);
    } catch (err) {
      setError(err.response.data.error || 'An error occurred. Please try again.');
      setMessage('');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Reset Password</h2>
        <p className="auth-subtitle">Enter a new password for your account.</p>
        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="password"
            className="auth-input"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            type="password"
            className="auth-input"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <button type="submit" className="auth-button">Reset Password</button>
        </form>
        {message && <p className="auth-message success">{message}</p>}
        {error && <p className="auth-message error">{error}</p>}
      </div>
    </div>
  );
};

export default withRouter(ResetPassword);